// extracted by mini-css-extract-plugin
export default {"main_song_page":"style_main_song_page__nVYTu","song_page":"style_song_page__uIoW9","song_header":"style_song_header__8tzGV"};